// Chữ hiển thị cho chỗ ngồi (thuần, dùng ở trang quản trị).

/** "Team HT · Ghế 3". */
export const seatLabel = (tableName: string, number: number): string =>
  `${tableName} · Ghế ${number}`;

/**
 * Cắt tên dài để vừa trong vòng ghế: tên ≤ `max` ký tự giữ nguyên, dài hơn thì giữ `max` ký tự đầu
 * rồi thêm "…" (ví dụ 'Nguyễn Thị Phương Thảo' -> 'Nguyễn T…', kết quả dài nhất `max + 1` ký tự).
 */
export function shortName(name: string, max = 8): string {
  return name.length <= max ? name : `${name.slice(0, max)}…`;
}

/**
 * Tên bàn trong lòng bàn: tối đa 2 dòng, mỗi dòng ≤ `perLine` ký tự, ngắt ở khoảng trắng.
 * Không vừa 2 dòng thì dòng 2 bị cắt kèm "…"; một chữ dài hơn cả dòng thì cắt ngang chữ.
 */
export function tableNameLines(name: string, perLine = 12): string[] {
  const lines: string[] = [];
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .forEach((word) => {
      const last = lines[lines.length - 1];
      if (last !== undefined && `${last} ${word}`.length <= perLine) {
        lines[lines.length - 1] = `${last} ${word}`;
      } else {
        lines.push(word);
      }
    });
  if (lines.length <= 2 && lines.every((l) => l.length <= perLine)) return lines;
  const head = lines[0];
  const first = head.slice(0, perLine);
  const rest = [head.slice(perLine), ...lines.slice(1)].filter(Boolean).join(' ');
  if (!rest) return [first];
  return [first, rest.length <= perLine ? rest : shortName(rest, perLine - 1)];
}
